import usageAnalyticsService from "./usageAnalyticsService";

const SESSION_STORAGE_KEY = "usage_session_id";
const HEARTBEAT_INTERVAL_MS = 60_000;
const FLUSH_INTERVAL_MS = 5_000;
const FLUSH_MAX_QUEUE = 10;

let sessionId = null;
let heartbeatIntervalId = null;
let flushTimeoutId = null;
let eventQueue = [];
let visibilityListenerAttached = false;

function scheduleFlush() {
  if (flushTimeoutId) return;
  flushTimeoutId = setTimeout(() => {
    flushTimeoutId = null;
    flush();
  }, FLUSH_INTERVAL_MS);
}

async function flush() {
  if (eventQueue.length === 0) return;
  const batch = eventQueue;
  eventQueue = [];
  try {
    await usageAnalyticsService.recordEvents(batch);
  } catch (error) {
    console.warn("Falha ao registrar eventos de uso:", error);
  }
}

async function sendHeartbeat() {
  if (!sessionId || document.visibilityState !== "visible") return;
  try {
    await usageAnalyticsService.heartbeat(sessionId);
  } catch (error) {
    console.warn("Falha ao enviar heartbeat de uso:", error);
  }
}

function handleVisibilityChange() {
  if (document.visibilityState === "visible") {
    sendHeartbeat();
  }
}

export async function initSession() {
  if (sessionId) return sessionId;
  const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (stored) {
    sessionId = stored;
  } else {
    try {
      const res = await usageAnalyticsService.startSession();
      sessionId = String(res?.data?.id ?? res?.id);
      sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
    } catch (error) {
      console.warn("Falha ao iniciar sessão de uso:", error);
      return null;
    }
  }

  if (!heartbeatIntervalId) {
    heartbeatIntervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);
  }
  if (!visibilityListenerAttached) {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    visibilityListenerAttached = true;
  }
  return sessionId;
}

export function trackEvent(eventType, eventTarget, metadata = null) {
  if (!sessionId) return;
  eventQueue.push({
    fk_id_session: Number(sessionId),
    event_type: eventType,
    event_target: eventTarget,
    metadata,
    occurred_at: new Date().toISOString(),
  });
  if (eventQueue.length >= FLUSH_MAX_QUEUE) {
    if (flushTimeoutId) {
      clearTimeout(flushTimeoutId);
      flushTimeoutId = null;
    }
    flush();
  } else {
    scheduleFlush();
  }
}

export async function endSession() {
  if (!sessionId) return;
  if (heartbeatIntervalId) {
    clearInterval(heartbeatIntervalId);
    heartbeatIntervalId = null;
  }
  if (visibilityListenerAttached) {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    visibilityListenerAttached = false;
  }
  if (flushTimeoutId) {
    clearTimeout(flushTimeoutId);
    flushTimeoutId = null;
  }
  await flush();
  const closingId = sessionId;
  sessionId = null;
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
  try {
    await usageAnalyticsService.closeSession(closingId);
  } catch (error) {
    console.warn("Falha ao encerrar sessão de uso:", error);
  }
}
